import dayjs from 'dayjs';

import i18n from '@/i18n';
import {TIME_FORMATS} from '@/utils/timeFormats';

export type MedicationDateRangeParts = {
  start: string;
  end: string;
  endsSoon: boolean;
};

export function getMedicationDateRangeParts({
  startDate,
  endDate,
}: {
  startDate?: string | null;
  endDate?: string | null;
}): MedicationDateRangeParts | null {
  if (!startDate && !endDate) return null;

  return {
    start: startDate
      ? dayjs(startDate).format(TIME_FORMATS.date)
      : i18n.t('Not provided'),
    end: endDate ? dayjs(endDate).format(TIME_FORMATS.date) : i18n.t('Ongoing'),
    endsSoon: isMedicationEndingSoon(endDate),
  };
}

export function isMedicationEndingSoon(endDate?: string | null) {
  return Boolean(
    endDate && dayjs(endDate).isBefore(dayjs().add(3, 'days'), 'day')
  );
}

export function isMedicationCurrentByEndDate(endDate?: string | null) {
  return !endDate || !dayjs(endDate).isBefore(dayjs(), 'day');
}
